import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const supportedLanguages = ["pt", "en", "es"];
const fallbackLanguage = "en";
const savedLanguageKey = "soup_selected_language";

const normalizeLanguage = (language) => {
  const baseLanguage = (language || "").split("-")[0].toLowerCase();

  return supportedLanguages.includes(baseLanguage)
    ? baseLanguage
    : fallbackLanguage;
};

const getInitialLanguage = () => {
  if (typeof window === "undefined") {
    return fallbackLanguage;
  }

  const savedLanguage = window.localStorage.getItem(savedLanguageKey);

  if (savedLanguage) {
    return normalizeLanguage(savedLanguage);
  }

  const browserLanguage =
    window.navigator.languages?.[0] ||
    window.navigator.language ||
    fallbackLanguage;

  return normalizeLanguage(browserLanguage);
};

/*
 * React development server:
 *   http://localhost:3000
 *   -> /locales/en/translation.json
 *
 * Django development server:
 *   http://localhost:8000
 *   -> /static/locales/en/translation.json
 *
 * Production:
 *   https://soup.red
 *   -> /static/locales/en/translation.json
 */
const isReactDevServer =
  typeof window !== "undefined" && window.location.port === "3000";

const localesBasePath = isReactDevServer ? "/locales" : "/static/locales";

/*
 * Increment this value whenever translation files change,
 * or set REACT_APP_TRANSLATION_VERSION in the environment.
 *
 * This prevents users from receiving an old cached
 * translation.json after a deployment.
 */
const translationVersion = process.env.REACT_APP_TRANSLATION_VERSION || "1";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: getInitialLanguage(),

    fallbackLng: fallbackLanguage,

    supportedLngs: supportedLanguages,
    nonExplicitSupportedLngs: true,
    load: "languageOnly",

    backend: {
      loadPath: `${localesBasePath}/{{lng}}/translation.json?v=${translationVersion}`,
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  });

export { supportedLanguages, fallbackLanguage, savedLanguageKey };

export default i18n;
